require('./analytics')
require('./legacy-popover')
require('./announcement')
require('./inline-edit')
require('./dashboard')
require('./timing')
require('./search')
require('./csrf')
require('./help')
require('./suspension')
require('./last-login-timestamp')
require('./workflows')
require('./web-sdk')

// purely side-effects, folks
module.exports = Function()
